import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import MainInput from "../../component/atoms/input/mainInput";
import PretendardText from "../../component/atoms/text/pretendardText";
import { route } from "../../router/route";
import { errorHandler } from "../../util/errorHandler";
import { regExpression } from "../../util/regExpresstion";
import AccountApi from "../../api/account.api";
import { useCookies } from "react-cookie";

const Login = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [cookies, setCookie, removeCookie] = useCookies(["autoLogin"]);

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  // mounted
  useEffect(() => {
    if (searchParams.get("reflesh")) {
      const message401 = "로그인이 만료되었습니다. 다시 로그인해주세요.";
      toast(`${message401}`);
    }
  }, []);

  useEffect(() => {
    const allRefresh = searchParams.get("refresh");
    if (allRefresh) {
      removeCookie("autoLogin", { path: "/" });
    }
    if (!allRefresh && cookies.autoLogin) {
      autoLoginFunc();
    }
  }, []);

  const handleLogin = async () => {
    if (!(loginData.email && loginData.password)) {
      return;
    }
    if (!regExpression.email.test(loginData.email)) {
      toast("올바른 이메일 형식이 아닙니다.");
      return;
    }
    if (!regExpression.password.test(loginData.password)) {
      toast("올바른 비밀번호 형식이 아닙니다.");
      return;
    }

    let obj = {
      email: loginData.email,
      password: loginData.password,
    };

    try {
      let response = "";
      response = await AccountApi.login(
        {},
        {
          authorization: `Basic ${btoa(`${obj.email}:${obj.password}`)}`,
        }
      );

      sessionStorage.setItem("token", response.data.data.accessToken);
      const myInfoData = (await AccountApi.myInfo()).data.data.content;

      sessionStorage.setItem("id", myInfoData.id);
      sessionStorage.setItem("wc_admin_myInfo", JSON.stringify(myInfoData));
      sessionStorage.setItem(
        "accessMenu",
        JSON.stringify(myInfoData.readAuthorityList)
      );
      sessionStorage.setItem(
        "writeMenu",
        JSON.stringify(myInfoData.updateAuthorityList)
      );

      setCookie("autoLogin", true, { maxAge: 3600 * 24 * 14, path: "/" });

      if (myInfoData.readAuthorityList.includes("/admin/home")) {
        navigate(route.home);
      } else {
        navigate(route.home_empty);
      }
    } catch (error) {
      sessionStorage.clear();
      if (error.response) {
        if (error.response.status === 400) {
          return toast(`${error.response.data.message}`);
        }
      } else {
        toast("알 수 없는 오류가 발생했습니다.");
      }
      errorHandler(error);
    }
  };

  const autoLoginFunc = async () => {
    try {
      const response = await AccountApi.getNewToken();
      const newToken = response.data.data.accessToken;
      // new 액세스 토큰 변수 저장
      sessionStorage.setItem("token", newToken);

      const myInfoData = (await AccountApi.myInfo()).data.data.content;
      sessionStorage.setItem("id", myInfoData.id);
      sessionStorage.setItem("wc_admin_myInfo", JSON.stringify(myInfoData));
      sessionStorage.setItem(
        "accessMenu",
        JSON.stringify(myInfoData.readAuthorityList)
      );
      sessionStorage.setItem(
        "writeMenu",
        JSON.stringify(myInfoData.updateAuthorityList)
      );

      if (myInfoData.readAuthorityList.includes("/admin/home")) {
        navigate(route.home);
      } else {
        navigate(route.home_empty);
      }
    } catch (error) {
      window.location.href = route.login + "?refresh=true";

      if (error?.response?.status === 401) {
        return;
      }
      if (error?.response?.status === 404) {
        return;
      }

      errorHandler(error);
    }
  };

  return (
    <LoginWrapper>
      <LoginBox>
        <PretendardText
          style={{
            fontSize: "30px",
            fontWeight: "700",
            lineHeight: "41.5px",
            letterSpacing: "-0.21px",
            color: "#f3f3f3",
            marginBottom: "40px",
          }}
        >
          로그인
        </PretendardText>
        <LoginInputWrapper>
          <LoginInputForm>
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "22px",
                color: "#aaa",
              }}
            >
              이메일
            </PretendardText>
            <MainInput
              type={"email"}
              placeholder={"이메일을 입력해 주세요."}
              style={{ width: "343px" }}
              value={loginData.email}
              onChange={(e) => {
                setLoginData({ ...loginData, email: e.target.value });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
            />
          </LoginInputForm>
          <LoginInputForm>
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "22px",
                color: "#aaa",
              }}
            >
              비밀번호
            </PretendardText>
            <MainInput
              type={"password"}
              placeholder={"비밀번호를 입력해 주세요."}
              style={{ width: "343px" }}
              value={loginData.password}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
            />
          </LoginInputForm>
        </LoginInputWrapper>
        <LoginBtnWrapper>
          <LoginBtn
            disabled={!(loginData.email && loginData.password)}
            onClick={() => {
              handleLogin();
            }}
          >
            로그인
          </LoginBtn>
          {/* <JoinBtn onClick={() => navigate(route.join)}>회원가입</JoinBtn> */}
        </LoginBtnWrapper>
      </LoginBox>
    </LoginWrapper>
  );
};

export default Login;

const LoginWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoginBox = styled.div.attrs((props) => {})`
  width: 518px;
  /* height: 574px; */
  height: 526px;
  padding: 86px 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  background: #272829;
  box-shadow: 4px 8px 36px 0px rgba(0, 0, 0, 0.05);
`;

const LoginInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
`;

const LoginInputForm = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
`;

const LoginBtnWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const LoginBtn = styled.button.attrs((props) => {})`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.disabled ? "#313233" : "#27beff")};
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  color: #f3f3f3;
  border-radius: 3px;

  &:hover {
    background-color: #009bde;
  }

  &:disabled:hover {
    background-color: #313233;
  }
`;

// const JoinBtn = styled.button.attrs((props) => {})`
//   width: 100%;
//   height: 48px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: 1px solid rgba(255, 255, 255, 0.12);
//   background: ${(props) => (props.disabled ? "#313233" : "transparent")};
//   font-family: "Pretendard";
//   font-size: 15px;
//   font-weight: 600;
//   line-height: 22px;
//   color: #939393;
//   border-radius: 3px;

//   &:hover {
//     background-color: #272829;
//   }
// `;
